import angular from 'angular';
import commissionExpectedSummary from './commissionExpectedSummary';

export default angular
  .module(
    'commission.scenes.commissionManagement.scenes.commissionLanding.scenes.commissionExpectedSummary',
    [],
  )
  .component('commissionExpectedSummary', commissionExpectedSummary).name;
